import { render, staticRenderFns } from "./basePopup.vue?vue&type=template&id=f6ac1ec2&scoped=true"
import script from "./basePopup.vue?vue&type=script&lang=js"
export * from "./basePopup.vue?vue&type=script&lang=js"
import style0 from "./basePopup.vue?vue&type=style&index=0&id=f6ac1ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ac1ec2",
  null
  
)

export default component.exports